import gql from 'graphql-tag';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      showFacebookCreateDialog: false,
      showInstagramCreateDialog: false,
      showEmailCreateDialog: false,
      showWechatCreateDialog: false,
      showWhatsAppWebCreateDialog: false,
      showTelegramCreateDialog: false,
      channelTypeConfig: {
        facebook: { icon: 'fa-facebook', color: '#4767aa', title: 'Facebook', alwaysShow: true },
        twitter: { icon: 'fa-twitter', color: '#1da1f2', title: 'Twitter', alwaysShow: true },
        instagram: { icon: 'fa-instagram', color: '#ed1f65', title: 'Instagram', alwaysShow: true },
        // whatsapp: { icon: 'fa-whatsapp', color: '#0fa251', title: 'WhatsApp' },
        telegram: { icon: 'fa-telegram', color: '#1da1f2', title: 'Telegram', alwaysShow: true },
        email: {
          icon: 'fa-envelope',
          color: '#1da1f2',
          title: 'E-Mail',
          method: 'Email',
          alwaysShow: true,
        },
        gmail: {
          icon: 'fa-google',
          color: '#5b0a91',
          title: 'Colony E-Mail',
          method: 'ColonyEmail',
          alwaysShow: false,
        },
        tiktok: {
          icon: 'fa-play-circle',
          color: '#000101',
          title: 'TikTok',
          method: 'TikTok',
          alwaysShow: false,
        },
      },
    };
  },

  computed: {
    ...mapState('user', ['me']),
  },

  apollo: {
    channelList: {
      query: gql`
        {
          channelList(live: true) {
            id
            handle
            channelTypeTitle
          }
        }
      `,
    },
  },

  methods: {
    refetchChannelList() {
      this.$apollo.queries.channelList.refetch();
      this.createChannelPrompt();
    },
    handleFacebookVisibilityChange(value) {
      this.showFacebookCreateDialog = value;
    },
    handleInstagramVisibilityChange(value) {
      this.showInstagramCreateDialog = value;
    },
    handleEmailDialogVisibilityChange(value) {
      this.showEmailCreateDialog = value;
    },
    handleCellfindDialogVisibilityChange(value) {
      this.showCellfindCreateDialog = value;
    },
    handleWechatDialogVisibilityChange(value) {
      this.showWechatCreateDialog = value;
    },
    handleWhatsappWebDialogVisibilityChange(value) {
      this.showWhatsAppWebCreateDialog = value;
    },
    handleTelegramDialogVisibilityChange(value) {
      this.showTelegramCreateDialog = value;
    },
    createChannelPrompt() {
      this.$confirm(
        'Would you like to create a campaign for this new channel?',
        'Create Campaign',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        },
      ).then(() => {
        this.$router.push({ path: 'campaigns', query: { create: true } });
      });
    },
    connectTwitter() {
      this.$store.dispatch('channel/addTwitterChannel', this.me.id);
    },
    connectFacebook() {
      this.showFacebookCreateDialog = true;
    },
    connectTelegram() {
      this.showTelegramCreateDialog = true;
    },
    connectInstagram() {
      this.showInstagramCreateDialog = true;
    },
    connectWhatsApp() {
      this.showWhatsAppWebCreateDialog = true;
    },
    connectWeChat() {
      this.showWechatCreateDialog = true;
    },
    connectEmail() {
      this.showEmailCreateDialog = true;
    },
    connectColonyEmail() {
      window.open(process.env.API_EMAIL, '_blank');
    },
    connectTikTok() {
      this.$store.dispatch('channel/addTikTokChannel', this.me.id);
    },
    connectChannel(channelType) {
      const methodName = `connect${channelType}`;
      this[methodName]();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/channel/channelCreateMixin.js